export const SOURCES = {
  FITBIT: 'fitbit',
  SIDEKICK_CORE: 'sidekick_core',
}
